(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function() {
  // Initialize the carousel behavior if enabled in settings (arrows removed)
  function initRelatedCarousel() {
    var section = document.querySelector('.related-products');
    if (!section) return;

    var isCarousel = section.dataset.carousel === 'true' || section.dataset.carousel === '1';
    if (!isCarousel) return;

    var grid = section.querySelector('.product-grid');
    if (!grid) return;

    // Ensure class presence
    if (!grid.classList.contains('is-carousel')) {
      grid.classList.add('is-carousel');
    }

    // Avoid double-initialization
    if (grid.dataset.carouselInit === 'true') return;
    grid.dataset.carouselInit = 'true';

    // No arrows anymore—just make sure layout reacts to size/scroll
    function updateState() {
      // nothing to toggle now, but keep for future extensibility
    }

    grid.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(updateState);
      ro.observe(grid);
    }
    updateState();
  }

  // Fetch recommendations and re-init after injection
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector('.related-products');
    if (productRecommendationsSection === null) { return; }

    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;

        var incoming = container.querySelector('.related-products');
        if (incoming) {
          productRecommendationsSection.innerHTML = incoming.innerHTML;
          initRelatedCarousel();
        }
      }
    };
    request.send();
  };

  // Re-fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
      initRelatedCarousel();
    }
  });

  // Initial fetch + init
  loadProductRecommendationsIntoSection();
  initRelatedCarousel();
})();

  } catch(e) { console.error(e); }
})();
})();
